import { Container, Divider, Grid, Typography } from '@material-ui/core'; 
import React, { useEffect, useState } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom'; 
import { useAuth } from '../../hooks/auth'; 
import { useStyles } from './Style';  
import TextField from '../../components/Form/TextField'; 
import MUIDataTable from "mui-datatables"
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import getDefaultGridOptions, { defaultGridTheme, defaultHeaderOptions } from '../../utils/componentUtils'
import LoadingUI from '../../components/ui/LoadingUI'
import PageTitle from '../../components/ui/PageTitleUI'
import MvmApi from '../../services/MvmApi'
import { MvmInvoiceGet } from '../../interfaces/Mvm'; 
import ButtonUI from '../../components/ui/ButtonUI'
import { Search as SearchIcon } from '@material-ui/icons'
import utilsDate from '../../utils/Date';
import permissions from '../../utils/Permissions';
import SelectSupplier from '../../components/Form/SelectSupplier'
import DateField from '../../components/Form/Date';
import SelectVehicleType from '../../components/Form/SelectVehicleType'
import { OUTGOING_MATERIAL_INVOICE_TYPE } from '../../utils/constants';

interface IFormInput {
    mvmNumber: string;
    mvmNumberUnique: string;
    submitDate?: Date | null;
    entranceDate?: Date | null;
    exitDate?: Date | null;
    outgoingRequests: any;
    sort: string;
    sortDir: string;
}

const MvmInvoiceSearch: React.FC = () => {
    const history = useHistory()
    const classes = useStyles()
    const { t } = useTranslation("Mvm")
    const { user, isMopar, hasPermission } = useAuth()
    const { t: _t } = useTranslation("General")  
    const [loading, setLoading] = useState(false) 
    const [mvms, setMvms] = useState<any>() 
    const { t: it } = useTranslation(isMopar() ? "MvmInvoiceMopar" : "MvmInvoice");
    const { control, handleSubmit, setValue, getValues } = useForm<IFormInput>(
    {
        defaultValues: { mvmNumber: '', mvmNumberUnique: '', submitDate: null, entranceDate: null, exitDate: null }
    }) 

    const columns = [
        {
            name: 'mvmNumber',
            label: String(t('mvmNumber')),   
            options: {
                sort: true, 
                setCellProps: () => ({                       
                    align: "left",
                }),
            }
        },
        {
            name: 'invoiceType',
            label: t("invoiceType"),
            options: {
                ...defaultHeaderOptions,
                sort: false,
                customBodyRender: (value: any, tableMeta: any) => (
                    OUTGOING_MATERIAL_INVOICE_TYPE.find((x: any) => x.code === value)?.label
                )
            }
        },
        {
            name: 'invoiceKey',
            label: String(t('invoiceKey')),
            options: {
                ...defaultHeaderOptions,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                sort: false, 
            }
        },
        {
            name: 'invoiceNumber',
            label: String(t('invoiceNumber')),
            options: {
                ...defaultHeaderOptions,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                sort: false
            }
        },
        {
            name: 'entranceDate',
            label: String(t('entranceDate')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        },
        {
            name: 'exitDate',
            label: String(t('exitDate')),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any) => {
                    return utilsDate.DateTimeShort(value);
                }
            }
        }, 
    ]

    useEffect(() => { 
        const companyId = user.company.companyID;
        if (+companyId !== 241 || !hasPermission(permissions.MVM.IncOutgoingMaterialInvoice))
            history.replace('NoPermission');

        var data = getValues()
        onSubmit(data)
    }, [history, user]); 
 
    const onSubmit = (data: any) => { 
        setLoading(true) 
        let search: MvmInvoiceGet = { 
            mvmNumber: data.mvmNumber,
            companyId: Number(user.company.companyID),  
            shippingSupplierId: data.shippingSupplier?.code,
            submitDate: data.submitDate,
            entranceDate: data.entranceDate,
            exitDate: data.exitDate,
            vehicleType: data.vehicleType?.code,
            vehiclePlateNumber: data.vehiclePlateNumber,
            driverName: data.driverName,
            cTeNumber: data.cTeNumber,
            shippingCompanySupplierId: data.shippingCompanySupplier?.code
        }

        MvmApi.searchMvmInvoice(search)
            .then(result => { 
                if (result) {
                    setMvms(result) 
                }
                else {
                    setMvms([]) 
                }
            }).catch(() => {
                setMvms([]);
            }).finally(() => {
                setLoading(false);
            })
    }

    return (
        <Container maxWidth={false} component="main"> 
            <PageTitle title={"Nota Fiscal de Saída de Materiais"} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <form onSubmit={handleSubmit(onSubmit)}>  
                        <Grid container spacing={1}>
                            <Grid item xs={6} style={{ padding: "0px", display: 'flex', alignItems: 'center' }}>
                                <Typography className={classes.root}>
                                    {t("titleSearch")}
                                </Typography>
                            </Grid>

                            <Grid item xs={6} style={{ padding: "0px", textAlign: 'right' }}>
                                <ButtonUI type="submit" color="primary" startIcon={<SearchIcon />}>{t("search")}</ButtonUI>
                            </Grid>
                        </Grid>
                        <Divider style={{ marginTop: '10px' }} /> 
                        <Grid container spacing={1}>
                            <Grid item xs={3}>
                                <TextField 
                                    label={t("mvmNumber")} 
                                    name="mvmNumber" 
                                    control={control} 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0,9) }}
                                    fullWidth
                                />                                
                            </Grid>
                            <Grid item xs={8}> 
                                <SelectSupplier 
                                    name={"shippingSupplier"}
                                    label={t("shippingSupplier")} 
                                    control={control} 
                                    multiple={false}
                                    style={{width: '100%'}} 
                                />
                            </Grid>
                        
                            <Grid item xs={3}> 
                                <DateField 
                                    label={t("entranceDate")} 
                                    name="entranceDate" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}   
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={2}> 
                                <DateField 
                                    label={t("exitDate")} 
                                    name="exitDate" 
                                    control={control} 
                                    InputLabelProps={{shrink:true}}   
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField 
                                    label={t("vehiclePlateNumber")} 
                                    name="vehiclePlateNumber" 
                                    control={control} 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0,9) }}
                                    fullWidth
                                    mask="aaa9*99"
                                />   
                            </Grid>
                            <Grid item xs={2}> 
                                <SelectVehicleType 
                                    label={t('vehicleType')} 
                                    name={'vehicleType'} 
                                    control={control}
                                /> 
                            </Grid>
                            <Grid item xs={3}>
                                <TextField 
                                    label={t("driverName")} 
                                    name="driverName" 
                                    control={control} 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0,100) }}
                                    fullWidth
                                />   
                            </Grid>
                            <Grid item xs={3}>
                                <TextField 
                                    label={t("cTeNumber")} 
                                    name="cTeNumber" 
                                    control={control} 
                                    onInput={(e) => { (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.slice(0,9) }}
                                    fullWidth
                                />   
                            </Grid>
                            <Grid item xs={8}>
                                <SelectSupplier 
                                    name={"shippingCompanySupplier"}
                                    label={t("shippingCompanySupplier")} 
                                    control={control} 
                                    multiple={false}
                                    style={{width: '100%'}} 
                                    serviceType={'T'}
                                /> 
                            </Grid>
                        </Grid>
                    </form>  
                    {loading ? <LoadingUI /> :
                        <MuiThemeProvider theme={defaultGridTheme}>
                            <MUIDataTable
                                title=""
                                data={mvms}
                                columns={columns}  
                                options={{
                                    ...getDefaultGridOptions(_t),
                                    serverSide: true,
                                    pagination: false,
                                    sort: false,
                                    sortOrder: { name: getValues().sort, direction: getValues().sortDir == 'asc' ? 'asc' : 'desc' },
                                    selectToolbarPlacement: "none",
                                    selectableRows: 'none',
                                    filter: false,
                                    search: false,
                                    print: false,
                                    viewColumns: false,  
                                    download: true,
                                    downloadOptions: {
                                        filename: t("fileNameMvmInvoice"),
                                        separator: ';',
                                        filterOptions:{
                                            useDisplayedRowsOnly: true,
                                            useDisplayedColumnsOnly: true,
                                        }
                                    },   
                                }}
                            />
                        </MuiThemeProvider>
                    }
                </div>
            </div>
        </Container>
    )
}
export default MvmInvoiceSearch;
